import React from 'react';
import PropTypes from 'prop-types';
import { AlphanumericInput } from '@lmig/lmds-react-alphanumeric-input';
import './TextBox.scss';
import classNames from 'classnames';
import { FieldGroup } from '@lmig/lmds-react-field-group';

const TextBox = ({
    placeholder,
    marginLeft,
    marginRight,
    inputRef,
    helper,
    maskFormat,
    inputComponent,
    heapAttributes,
    datacy,
    ...TextFieldProps
}) => {
    const { error } = { ...TextFieldProps };

    const textBoxClasses = classNames({
        textBox: true,
        hasError: error
    });

    return (
        <div
            className={textBoxClasses}
            data-heap={heapAttributes || TextFieldProps.name}
            style={{
                marginLeft: `${marginLeft}px`,
                marginRight: `${marginRight}px`
            }}>
            <span className="text-field">
                <FieldGroup
                    messages={error ? [{ text: helper, type: 'error' }] : []}
                    datacy={datacy}>
                    <AlphanumericInput
                        onChange={TextFieldProps.onChange}
                        innerRef={inputRef}
                        labelVisual={placeholder}
                        highlightType={error ? 'error' : null}
                        name={TextFieldProps.name}
                    />
                </FieldGroup>
            </span>
        </div>
    );
};

TextBox.propTypes = {
    placeholder: PropTypes.string.isRequired
};

TextBox.defaultProps = {
    marginLeft: 10,
    marginRight: 10,
    maskFormat: null
};

export default TextBox;



// WEBPACK FOOTER //
// ./src/components/TextBox/TextBox.jsx